export default "__VITE_ASSET__DHDcAcQC__"